module.exports = {
  translations: {
    // metamask
    'metamask.pleaseInstallFirst': 'Please install MetaMask first!',
    'metamask.youNeedSignMessage': 'You need to sign the message to be able to use system!',
    // award
    'award.pleaseSignIn': 'Please sign in to\nverify your reward',
    'award.signInUsingTwitter': 'Sign in using Twitter',
    'award.congratulation': 'Congratulation!',
    'award.openLinkBelow': 'Please open this link on mobile to get it.',
    'award.gotoTheLottery': 'Then on Pantograph.app, please go to the lottery and draw to win your favorite product.',
    'award.termOf': 'Terms of Twitter Campaign',
    'award.sorry': 'Sorry!',
    'award.campaignHasEnded': 'You have not met the criteria or the Campain has ended. \nPlease review the content of the tweet.',
    'award.pleaseOpenTheWebsite': 'Please open the website on Chrome or Safari browser',
    'award.notice': 'Notice',
    'award.pleaseAllowPopup': 'Please allow popup to sign in.',
    'award.details': 'Details',
    'award.installTheApp': '1. Install the app',
    'award.signInTwitter': '2. Sign in Twitter',
    'award.specializedAppRequiredToReceive': 'A specialized app is required to receive Digital card.',
    'award.afterInstallingTheApp': 'After installing the app, please sign into Twitter.',
    'award.tapTheUrl': 'Tap the URL to receive Digital card.',
    'award.caseYouCanNotSignIn': 'In case you can’t sign in, please try again in a few minutes.',
    'award.copied': 'Copied',
    'award.serverBusy': 'Server Busy',
    'award.theServerIsCurrentlyBusy': 'The server is currently too busy processing requests.\nPlease wait a moment and try your request again.',
    'award.argeeTheTerms': 'By participating in the campaign, you agree to the Terms of service',
    // footer
    'footer.policy': 'Privacy policy',
    'footer.terms': 'Terms of service',
    'footer.commercial': 'Specified commercial transactions',
    'footer.paymentServices': 'Payment Services Act'
  }
}